import { render, staticRenderFns } from "./QuotationFloatActionButton.vue?vue&type=template&id=2c0fc528&scoped=true"
import script from "./QuotationFloatActionButton.vue?vue&type=script&lang=js"
export * from "./QuotationFloatActionButton.vue?vue&type=script&lang=js"
import style0 from "./QuotationFloatActionButton.vue?vue&type=style&index=0&id=2c0fc528&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0fc528",
  null
  
)

export default component.exports